export default function BudgetsEntries() {
  return (
    <div>
      <table id="filetable">
         <tr>
          <th>File Name</th>
          <th>Date Posted</th>
        </tr>
        {/*End File*/}
         {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/budgets/2026-FINAL-BUDGET-WITH-SUMMARY-SHEET.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; 2026 Final Budget with summary sheet
            </a>
          </td>
          <td>1/10/2026</td>
        </tr>
        {/*End File*/}
          {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/budgets/2026-preliminary-budget.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; 2026 Preliminary Budget
            </a>
          </td>
          <td>11/19/2025</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/budgets/2025-FINAL-BUDGET.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; 2025 Final Budget
            </a>
          </td>
          <td>01/20/2025</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/budgets/2025-preliminary-budget.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; 2025 Preliminary Budget
            </a>
          </td>
          <td>11/20/2024</td>
        </tr>
        {/*End File*/}
        {/*Start File*/}
        <tr>
          <td>
            <a href="../docs/budgets/2024-FINAL-BUDGET.pdf" target="_blank" rel="noopener noreferrer">
              <i className="fa-solid fa-file-pdf fa-xl"></i>
              &nbsp; 2024 Final Budget
            </a>
          </td>
          <td>09/17/2024</td>
        </tr>
        {/*End File*/}
      </table>
    </div>
  );
}
